import React, { useContext, createRef } from 'react';
import PropTypes from 'prop-types';

// import { setValue, addValue, removeValue } from 'actions/fieldActions';
import Types from 'constants/types';
import LocaleContext from 'constants/localization';

import InputWrapper from '../common/InputWrapper';
import { getInputIndex } from 'helpers/actionHelpers';
import Form from 'react-bootstrap/Form';
import DateEdit from './DateEdit';
import RichTextEdit from './RichTextEdit';

const LiteralEdit = (props) => {
  const [validationTimeout, setValidationTimeout] = React.useState(0);
  const LS = useContext(LocaleContext);
  const inputRef = createRef();

  let { field, validateInput, timeout, error } = props;
  let { minOccurs, pattern, min, max, step, richText } = field.props;
  let onChange = e => field.setValue(getInputIndex(e), e.target.value);
  
  if (validateInput) {
    timeout = timeout || 1000;

    onChange = e => {
      if (validationTimeout) {
        clearTimeout(validationTimeout);
      }
      field.setValue(getInputIndex(e), e.target.value);
      e.persist();
      setValidationTimeout(setTimeout(() => 
        validateInput(e.target.value, getInputIndex(e)), timeout));
    };
  }

  const defaultProps = {
    onChange,
    required: minOccurs > 0,
    pattern,
    disabled: field.disabled,
    ref: inputRef,
    onWheel: () => inputRef.current.blur() // SPEC-292 disable scroll
  };

  const input = (function(type) {
    switch(type) {
    case Types.XSD.STRING:
      return <Form.Control type="text" {...defaultProps} />;
  
    case Types.XSD.INT:
    case Types.XSD.INTEGER:
      return  <Form.Control min={min || '0'} max={2147483647} step={step || '1'} 
        type="number" {...defaultProps}  pattern={pattern || '\\d*'} />;
  
    case Types.XSD.DATE:
    case Types.XSD.DATETIME: // finnish date locale for consistent date input
      return <DateEdit locale='fi' {...{...defaultProps, ref: null}} />;
  
    case Types.XSD.DECIMAL:
    case Types.XSD.DOUBLE:
      return <Form.Control min={min || '0'} max={max} step={step || '0.01'} 
        type="number" {...defaultProps} pattern={pattern || '[0-9.,]+'} />;
  
    case Types.PROFIUM.LONGSTRING:
      if(richText){
	    return <RichTextEdit {...defaultProps} />;
      }else{
      	return <Form.Control as="textarea" {...defaultProps} />;
      }

    default:
      return <p>error?</p>;
    }
  })(field.type);

  // No values -> input with empty value, index 0
  if (field.values.length === 0) {
    field.values.push('');
  }

  const inputs = field.values.map((value, index) => {
    return (
      <div className="value" key={index}>
        {
          React.cloneElement(input, {value, index})
        }
        <Form.Control.Feedback type="invalid">
          <span>{LS.error.fieldValidation}</span>
        </Form.Control.Feedback>
      </div>
    );
  });

  return <InputWrapper {...{...props, error, inputs}} />;
};

LiteralEdit.propTypes = {
  field: PropTypes.object.isRequired,
};

export default LiteralEdit;